module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker45-api.relevant-digital.com/"}};